var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { attrs: { fluid: "lg" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    [
                      _c("div", { staticClass: "text-center mb-3" }, [
                        _c("img", {
                          staticClass: "mb-3 logo",
                          attrs: { src: "/imgs/logoAbelha.png", alt: "" }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-skeleton-wrapper",
                        {
                          attrs: { loading: _vm.firstLoading },
                          scopedSlots: _vm._u([
                            {
                              key: "loading",
                              fn: function() {
                                return [
                                  _c(
                                    "b-card",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "100%" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c("b-skeleton", {
                                            attrs: {
                                              height: "40%",
                                              width: "100%"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  type: "input",
                                                  width: "50%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton-img", {
                                                attrs: { width: "50%" }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-skeleton-img", {
                                                attrs: { width: "50%" }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-3" },
                                        [
                                          _c("b-skeleton", {
                                            attrs: { width: "100%" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          !_vm.firstLoading
                            ? [
                                _vm.data.distribuidor
                                  ? _c(
                                      "div",
                                      { staticClass: "text-center mt-3" },
                                      [
                                        _c(
                                          "h2",
                                          { staticClass: "mt-3 distribuidor" },
                                          [
                                            _vm._v(
                                              "\n                  Olá " +
                                                _vm._s(
                                                  _vm.data.distribuidor.nome
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("h5", { staticClass: "mt-3 mb-3 title" }, [
                                  _c("b", [
                                    _vm._v(
                                      "\n                  Estamos em período de solicitação de catálogos para a campanha " +
                                        _vm._s(_vm.data.campanha) +
                                        "\n                "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.data.distribuidor
                                  ? _c("b-row", { staticClass: "mt-3 mb-3" }, [
                                      _c("h6", [
                                        _vm._v(
                                          "\n                  Código do Distribuidor: " +
                                            _vm._s(
                                              _vm.data.distribuidor.codigo
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-card",
                                          [
                                            _c("span", [_vm._v("*")]),
                                            _vm._v(
                                              " Quantidade de Catálogos:\n                    "
                                            ),
                                            _c("b-form-input", {
                                              directives: [
                                                {
                                                  name: "mask",
                                                  rawName: "v-mask",
                                                  value: ["##########"],
                                                  expression: "['##########']"
                                                }
                                              ],
                                              staticClass: "mt-3",
                                              attrs: {
                                                placeholder: "Quantidade"
                                              },
                                              model: {
                                                value: _vm.data.quantidade,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.data,
                                                    "quantidade",
                                                    $$v
                                                  )
                                                },
                                                expression: "data.quantidade"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-text",
                                              {
                                                attrs: { id: "input-live-help" }
                                              },
                                              [
                                                _vm._v(
                                                  "O valor do frete é calculado a partir da quantidade de\n                      catálogos!"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { staticClass: "text-center" },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            "Atenção! Todas solicitações passará por análise de aproveitamento!"
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          disabled: _vm.loading,
                                          variant: "success"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.salvar()
                                          }
                                        }
                                      },
                                      [
                                        _vm.loading
                                          ? _c("b-spinner", {
                                              attrs: {
                                                small: "",
                                                label: "Loading..."
                                              }
                                            })
                                          : _c("i", {
                                              staticClass: "fas fa-save"
                                            }),
                                        _vm._v(
                                          "\n                  Salvar\n                "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57da4f1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57da4f1a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/OperacaoCatalogo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-57da4f1a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/OperacaoCatalogo.vue
// module chunks = 2